export const trueblack = '#000000'
export const black = '#393e4c'
export const orange = '#ff6c00'
export const lightorange = '#ff8a34'
export const paleorange = '#fdeee3'
export const lightgray = '#a5a5a5'
export const darkgray = '#3a3a3a'
export const white = '#f7f7f7'
export const floralwhite = '#faf8f4'
export const truewhite = '#ffffff'
export const errorRed = '#d90a0a'
export const lightgreen = '#00d64a'
export const cautionRed = '#ff0000'

export const accentColor = '#02B7B0'
export const accentLightColor = '#F4FFFF'
export const defaultShadow = '3px 6px 10px #9C9DA099'

export const facebookBlue = '#3b5998'
export const facebookBlueLight = '#277ef2'
export const signoutGray = '#898989'

export const _menuborder = '#5d5d5d'
export const _menuicon = '#cdcdcd'
export const _menuhover = '#ab6e0c'
export const _menuorange = '#fd7415'

export const _modaloverlay = '#2b2e38'
export const _modalunderline = '#0a0a0a'

export const _membertopbg = '#f2f3f7'
export const _membertopborder = '#c0c0c0'

export const _profilemenubg = '#393e4c'
export const _profilehrborder = '#eeeeee'
export const _profileitemborder = '#dddddd'
export const _profilegreen = '#02b7b0'
export const _profilegray = '#bbbbbb'
export const _profileoverlay = '#c8c8c8'

export const _telborder = '#cccccc'

export const _cardgradient = `linear-gradient(150deg, ${black}, #6b6f79)`
export const _cardsubtitle = '#bebebe'
export const _cardinnershadow = '1px 2px 8px #d4d4d4'
export const _contributionborder = '#80dbd7'
export const _contributiontext = '#02b7b0'
export const _inversingbuttonshadow = '0 3px 6px #c4c4c6'
export const _contributionmenubuttongradient = `linear-gradient(150deg, ${_contributionborder}, #0286b7)`
export const _contributionsidebarshadow = '3px 0 4px -4px #999999'
export const _contributionssearchtitle = '#bbbbbb'
export const _contributionssearchborder = '#e6e6e6'
export const _contributionssearchShadow = '0 3px 4px -4px #999999'
export const _contributionsTextarea = '#d6d8da'

export const _messagesnavshadow = '3px 0 6px #393e4c14'
export const _messagesnavbg = '#ffffff40'
export const _messageroomborder = '#f4f4f4'

export const _searchbg = '#F8F8F8'
export const _messagesbg = '#f7f9fc'
export const _messagebg = '#ffffff'
export const _mymessagebg = '#02b7b0'
export const _mymessage = '#ffffff'
export const _messageformborder = '#e2e2e2'
export const _messageformbg = '#ffffff'
export const _messagebutton = '#ffffff'
export const _messagebuttonbg = '#02b7b0'
export const _messagecancelbutton = '#B2B2B2'
export const _messageiconfill = '#02b7b0'
export const _messagesecondary = '#cdcdcd'
export const _roomactivebg = '#f7f9fc'

export const _messagetemplateborder = '#efefef'
export const _messagetemplatebuttondisabled = '#cdcdcd'
export const _messagetemplatebuttonsaved = '#DEFFFE'
export const _greetsecondary = '#A09FA5'
export const _greetborder = '#efefef'

export const _tooltipbg = '#393E4C'
export const _tooltip = '#FFFFFF'
export const _tooltipshadow = '3px 6px 10px #cccccc'
export const _tooltiphover = '#02b7b0'
export const _popupbg = '#ffffff'

export const _feedbacksecondary = '#a19c9f'
export const _feedbacknote = '#02b7b0'
export const _feedbackstar = '#02b7b0'

export const _appointmentbuttonbg1 = '#ff6c00'
export const _appointmentbuttonbg1hovered = '#ffb076'
export const _appointmentbuttonbg2 = '#02b7b0'
export const _appointmentbuttonbg2hovered = '#7be8e4'
export const _appointmentbuttonbg3 = '#767676'
export const _appointmentbuttonbg3hovered = '#afafaf'
export const _appointmentbuttonbgsales = '#9c74fc'

export const _formplaceholdertext = '#bbbbbb'
export const _forminputback = '#f8f8f8'
export const _formborder = '#dedede'
export const _formalert = '#ff2626'
